export default __webpack_public_path__ + "static/media/brand_img01.66b31b24.png";